import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    name: '集成用例',
    type: 'ISRF_UC',
}
